const MAPA_HTML = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/**
 * Escapa texto antes de interpolarlo en HTML.
 *
 * Las ventanas de impresión se arman con window.open('') + document.write().
 * Esa ventana HEREDA el origen de la aplicación: un <script> escondido en el
 * nombre de un cliente o en una glosa se ejecutaría con la sesión del usuario
 * que imprime, con acceso a su token de Firebase.
 */
export const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => MAPA_HTML[c]);

// Formateo de moneda CLP (sin decimales — CLP estándar)
export const formatCLP = (value) => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value || 0);
};

// Formateo de intereses con hasta 2 decimales
// Útil para mostrar el desglose capital/interés de cuotas de préstamos
export const formatIntereses = (value) => {
  const num = value || 0;
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(num);
};

// Formateo de números
export const formatNumber = (value, decimals = 2) => {
  return new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value || 0);
};

// Cantidades de stock: hasta 3 decimales, sin ceros de relleno.
// Las sumas en coma flotante dejan colas como 0.7200000000000001.
export const formatCantidad = (value) =>
  new Intl.NumberFormat('es-CL', { maximumFractionDigits: 3 }).format(Number(value) || 0);

// Porcentaje
export const formatPercent = (value) => {
  return `${formatNumber(value * 100, 1)}%`;
};

// Fechas en formato dd/MM/yyyy
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

// Fecha y hora
export const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const time = d.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
  return `${formatDate(d)} ${time}`;
};

// Valor para <input type="datetime-local">, que trabaja en hora local.
// toISOString() es UTC y en Chile adelantaría la hora 3-4 horas.
export const aInputLocal = (d) =>
  new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

// Cómo se entrega un pedido de la web / QR (comanda.tipoPedido).
// 'llevar' es como lo manda el menú web; el servidor lo guarda como 'retiro'.
const TIPOS_PEDIDO = {
  retiro:   '🛍️ Para llevar',
  llevar:   '🛍️ Para llevar',
  delivery: '🛵 Delivery',
  mesa:     '🪑 Comer en el local',
};
export const etiquetaTipoPedido = (tipo) => TIPOS_PEDIDO[tipo] || '';

// IVA 19%
export const calculateIVA = (neto) => {
  return neto * 0.19;
};

export const addIVA = (neto) => {
  return neto * 1.19;
};

export const removeIVA = (bruto) => {
  return bruto / 1.19;
};

// Texto truncado
export const truncate = (text, length = 50) => {
  if (!text) return '';
  return text.length > length ? text.substring(0, length) + '...' : text;
};

// Capitalize
export const capitalize = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export default {
  formatCLP,
  formatIntereses,
  formatNumber,
  formatPercent,
  formatDate,
  formatDateTime,
  aInputLocal,
  calculateIVA,
  addIVA,
  removeIVA,
  truncate,
  capitalize,
  esc,
};
